import { render, staticRenderFns } from "./CrudListTable.vue?vue&type=template&id=631b7e08&scoped=true"
import script from "./CrudListTable.vue?vue&type=script&lang=js"
export * from "./CrudListTable.vue?vue&type=script&lang=js"
import style0 from "./CrudListTable.vue?vue&type=style&index=0&id=631b7e08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631b7e08",
  null
  
)

export default component.exports